/* Better Guides search only. No cart, payment or app handlers are replaced. */
(() => {
 'use strict';
 function init(root) {
  if (root.dataset.bgsReady) return;
  root.dataset.bgsReady = 'true';
  const form = root.querySelector('[data-bgs-query-form]');
  const input = root.querySelector('[data-bgs-query]');
  const clear = root.querySelector('[data-bgs-clear]');
  const panel = root.querySelector('[data-bgs-suggestions]');
  const list = root.querySelector('[data-bgs-options]');
  const status = root.querySelector('[data-bgs-status]');
  const facets = root.querySelector('[data-bgs-facet-form]');
  const filters = root.querySelector('[data-bgs-filters]');
  const media = window.matchMedia('(max-width: 899px)');
  if (filters) { filters.open = !media.matches; media.addEventListener('change', event => { filters.open = !event.matches; }); }
  root.querySelector('[data-bgs-sort]')?.addEventListener('change', () => facets.requestSubmit());
  root.querySelectorAll('.bgs-price-range').forEach(range => {
   const [min, max] = range.querySelectorAll('input');
   if (!min || !max) return;
   // Keep native range validation current before the browser submits the form.
   const update = () => { max.min = min.value !== '' ? min.value : '0'; };
   min.addEventListener('input', update);
   update();
  });
  if (!input || !form || !panel || !list) return;
  let enabled = root.dataset.predictive === 'true';
  try { const features = document.getElementById('shopify-features'); if (features && JSON.parse(features.textContent).predictiveSearch === false) enabled = false; } catch { /* Regular search remains available. */ }
  let controller, timer, version = 0, selected = -1, options = [], composing = false;
  function close() {
   clearTimeout(timer); version++; controller?.abort(); panel.hidden = true;
   input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); input.removeAttribute('aria-busy');
   options.forEach(option => option.setAttribute('aria-selected', 'false')); selected = -1;
  }
  function reset() { close(); input.value = ''; clear.hidden = true; status.textContent = ''; input.focus(); }
  clear.addEventListener('click', reset);
  clear.hidden = input.value.length === 0;
  input.addEventListener('input', () => { clear.hidden = input.value.length === 0; });
  form.addEventListener('submit', close);
  root.querySelector('[data-bgs-view-all]').addEventListener('click', close);
  document.addEventListener('click', event => { if (!root.querySelector('.bgs-search-area').contains(event.target)) close(); });
  root.querySelector('.bgs-search-area').addEventListener('focusout', event => { if (!root.querySelector('.bgs-search-area').contains(event.relatedTarget)) close(); });
  if (!enabled) return;
  input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-controls', list.id); input.setAttribute('aria-expanded', 'false'); input.setAttribute('aria-haspopup', 'listbox');
  function safeURL(raw, sameOrigin = true) {
   try { const url = new URL(raw, window.location.origin); return /^https?:$/.test(url.protocol) && (!sameOrigin || url.origin === window.location.origin) ? url : null; } catch { return null; }
  }
  function queryURL(text) {
   const url = new URL(form.action, window.location.origin);
   url.searchParams.set('q', text); url.searchParams.set('type', form.elements.namedItem('type').value); url.searchParams.set('options[prefix]', 'last');
   const view = form.elements.namedItem('view'); if (view) url.searchParams.set('view', view.value);
   return url;
  }
  function show(data) {
   list.replaceChildren(); options = []; selected = -1;
   const groups = [['queries', root.dataset.queriesLabel], ['products', root.dataset.productsLabel], ['collections', root.dataset.collectionsLabel], ['articles', root.dataset.articlesLabel], ['pages', root.dataset.pagesLabel]];
   for (const [kind, label] of groups) {
    const entries = Array.isArray(data?.resources?.results?.[kind]) ? data.resources.results[kind] : [];
    for (const item of entries.slice(0, kind === 'products' ? 3 : 2)) {
     if (options.length >= 8) break;
     const title = kind === 'queries' ? item.text : item.title;
     if (typeof title !== 'string' || !title.trim()) continue;
     const url = kind === 'queries' ? queryURL(title) : safeURL(item.url);
     if (!url) continue;
     const li = document.createElement('li'); li.id = `${list.id}-${options.length}`; li.setAttribute('role', 'option'); li.setAttribute('aria-selected', 'false');
     const link = document.createElement('a'); link.href = url.href; link.tabIndex = -1;
     const imageURL = safeURL(item.featured_image?.url || item.image || '', false);
     if (kind === 'products' && imageURL && (item.image || item.featured_image?.url)) {
      const image = document.createElement('img'); image.src = imageURL.href; image.alt = ''; image.width = 36; image.height = 48; image.loading = 'lazy'; link.append(image);
     } else { const icon = document.createElement('span'); icon.className = 'bgs-suggest-icon'; icon.textContent = '⌕'; icon.setAttribute('aria-hidden', 'true'); link.append(icon); }
     const text = document.createElement('span'); const name = document.createElement('strong'); name.textContent = title; const type = document.createElement('small'); type.textContent = label; text.append(name, type); link.append(text); li.append(link); list.append(li); options.push(li);
    }
   }
   panel.hidden = options.length === 0; input.setAttribute('aria-expanded', String(options.length > 0));
   status.textContent = options.length ? `${options.length} ${root.dataset.suggestCount}` : root.dataset.suggestEmpty;
  }
  async function request(query, stamp) {
   controller = new AbortController(); const pending = controller;
   try {
    const url = new URL(root.dataset.predictiveUrl || queryURL('').pathname + '/suggest', window.location.origin);
    if (url.origin !== window.location.origin) return;
    if (!url.pathname.endsWith('.json')) url.pathname += '.json';
    const scope = form.elements.namedItem('type').value;
    const types = scope.split(',').filter(type => ['product', 'article', 'page'].includes(type));
    if (types.includes('product')) types.push('collection');
    url.searchParams.set('q', query); url.searchParams.set('resources[type]', ['query', ...types].join(',')); url.searchParams.set('resources[limit]', '4'); url.searchParams.set('resources[limit_scope]', 'each');
    input.setAttribute('aria-busy', 'true'); status.textContent = root.dataset.loading;
    const response = await fetch(url, {signal:pending.signal, headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Predictive response unavailable');
    const data = await response.json();
    if (stamp !== version || input.value.trim() !== query || document.activeElement !== input) return;
    show(data);
   } catch (error) {
    if (error.name !== 'AbortError' && stamp === version) { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); status.textContent = root.dataset.suggestError; }
   } finally { if (stamp === version) input.removeAttribute('aria-busy'); }
  }
  function schedule() {
   close(); clear.hidden = input.value.length === 0;
   const query = input.value.trim(); if (composing || query.length < 2) { status.textContent = ''; return; }
   const stamp = version; timer = setTimeout(() => request(query, stamp), 220);
  }
  input.addEventListener('input', schedule);
  input.addEventListener('focus', () => { if (panel.hidden) schedule(); });
  input.addEventListener('compositionstart', () => { composing = true; close(); });
  input.addEventListener('compositionend', () => { composing = false; schedule(); });
  input.addEventListener('keydown', event => {
   if (event.isComposing || composing) return;
   if (event.key === 'Escape') { close(); return; }
   if (event.key === 'Tab') { close(); return; }
   if (panel.hidden || options.length === 0) return;
   if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
    event.preventDefault(); selected = event.key === 'ArrowDown' ? (selected + 1) % options.length : (selected <= 0 ? options.length - 1 : selected - 1);
    options.forEach((option, index) => option.setAttribute('aria-selected', String(index === selected)));
    input.setAttribute('aria-activedescendant', options[selected].id); options[selected].scrollIntoView({block:'nearest'});
   } else if (event.key === 'Enter' && selected >= 0) { event.preventDefault(); options[selected].querySelector('a').click(); close(); }
  });
 }
 function start(scope = document) { scope.querySelectorAll('[data-bgs-search]').forEach(init); }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once:true}); else start();
 document.addEventListener('shopify:section:load', event => start(event.target));
})();
